import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import getCookie, { setTeacherCookie, teacherState } from "../../Atom";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getUsersforStudent } from "../School-Districts/api";
import Group_299 from "../../assets/images/Group_299.png";
import Group_332 from "../../assets/images/Group_332.png";
import Group_305 from "../../assets/images/Group_305.png";
import key from "../../assets/images/pass2.png";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
// import Tooltip from '@mui/material/Tooltip';
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import {
  getAllClassby,
  createStudent,
  deleteStudent,
  editStudent,
} from "../School-Districts/api";
import "./userCss.css";
import {
  Table,
  TableContainer,
  TableSortLabel,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
// import Tooltip from '@mui/material/Tooltip';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const headCells = [
  {
    id: "loginId",
    numeric: false,
    disablePadding: true,
    label: "Login ID",
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Created On",
  },
];
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            backgroundColor: "transparent",
          }}
          align={"center"}
          padding={"normal"}
        >
          <span>
            <div className="text-Center fonted fontAdjust-700">UserType</div>
          </span>
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ backgroundColor: "transparent", marginX: "1px" }}
          >
            <TableSortLabel
              className="sort-header btn-wh2"
              sx={{
                display: "flex",
                justifyContent: "center",
                minHeight: "40px",
              }}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "desc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell
          sx={{
            backgroundColor: "transparent",
          }}
          align={"center"}
          padding={"normal"}
        >
          <span>
            <div className="text-Center fonted fontAdjust-700">Actions</div>
          </span>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
export default function User(props) {
  const history = useHistory();
  let search = window.location.search;
  let paramse = new URLSearchParams(search);
  let params = useParams();
  const emailRegex = /^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [paged, setPaged] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [noOfPages, setNoOfPages] = useState(0);
  const [query, setQuery] = useState("");
  const [pageLimit, setPageLimit] = useState(25);
  const [open, setOpen] = useState(false);
  const [myUser, setmyUser] = useState(teacherState);
  const [allStudent, setAllStudent] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [teacherId, setTeacherId] = useState();
  const [studentId, setStudentId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [upPwd, setUpPwd] = useState(false);
  const [loginId, setloginId] = useState("");
  const [password, setPassword] = useState("");
  const [classId, setClassId] = useState("");
  const [allClasses, setAllClasses] = useState([]);
  const [selectStudent, setSelectStudent] = useState(null);
  const [classID, setClassID] = useState("");
  const [editLoginIdState, setEditLoginIdState] = useState("");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [order, setOrder] = useState("desc");
  const [page, setPage] = useState(0);
  const [dense, setDense] = React.useState(false);
  const [oldName, setoldName] = useState(false);
  const [newID, setNewID] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMode, setSuccessMode] = useState(0);
  const [className, setClassName] = useState("");

  const [dataNewStudent, setDataNewStudent] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
  });

  const [studentTouched, setStudentTouched] = useState({
    loginId: false,
    password: false,
  });

  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setTeacherCookie({
        fName: null,
        userId: null,
        token: null,
        lName: null,
      });
      let hostname = window.location.host;
      ////console.loghostname, window.location.protocol)
      window.location.assign(
        `${window.location.protocol}//${hostname}/teachers`
      );
    });
  };

  const ValidationForm = (type) => {
    if (type == "add") {
      if (
        loginId.trim() == "" ||
        loginId == null ||
        password.trim() == "" ||
        password == null ||
        password.length < 8 ||
        classId.length < 1
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (loginId.trim() == "" || loginId == null || classId.length < 1) {
        return true;
      } else {
        return false;
      }
    }
  };

  const editingStudent = async () => {
    let res;
    if (editLoginIdState) {
      if (loginId && loginId.length >= 3) {
        res = await editStudent(
          classId,
          studentId,
          { loginId: loginId },
          myUser.token
        );
        setSuccessMode(2);
        setNewID(loginId.trim());
      } else
        feedBackMsg(
          true,
          "error",
          "Login ID should be atleast 3 characters long!"
        );
    } else {
      if (!upPwd && loginId && loginId.length < 4)
        return feedBackMsg(
          true,
          "error",
          "Login ID should be atleast 3 characters long!"
        );
      else {
        res = await editStudent(
          classId,
          studentId,
          { loginId: loginId },
          myUser.token
        );
        setSuccessMode(2);
        setNewID(loginId.trim());
      }
      if (upPwd && password && password.length < 8)
        return feedBackMsg(
          true,
          "error",
          "Password should be atleast 8 characters long!"
        );
      else {
        res = await editStudent(
          classId,
          studentId,
          { password: password },
          myUser.token
        );
        setSuccessMode(3);
      }
    }
    if (res) {
      if (res.error) {
        if (res.data.statusCode == 401) {
          logoutHandler();
        } else {
          feedBackMsg(true, "error", res.data.msg);
        }
      } else {
        feedBackMsg(true, "success", res.res.data.msg);
        let urlPage = parseInt(paramse.get("page")) || 0;
        let urlLimit = parseInt(paramse.get("limit")) || 25;
        let urlOrderBy =  paramse.get("orderBy") || "createdAt";
        let urlOrder =  paramse.get("order") || "desc";
          history.push({
            pathname: `/users/`,
            search:
              "?page=" +
              urlPage +
              `&limit=${urlLimit}&orderBy=${urlOrderBy}&order=${urlOrder}`,
          });
        getUsers(urlPage, urlLimit,urlOrderBy,urlOrder);
      }
      handleClose();
    }
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const handleClose = () => {
    setOpen(false);
    setAddMode(false);
    setEditMode(false);
    setDeleteMode(false);
    setSelectStudent(null);
    setloginId("");
    setClassId("");
    setPassword("");
    setClassID("");
    setClassId("");
    setEditLoginIdState(false);
    setUpPwd(false);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = allStudent?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    let urlPage = parseInt(paramse.get("page")) || 0;
    let urlLimit = parseInt(paramse.get("limit")) || 25;
    let urlSearch = parseInt(paramse.get("query")) || "";
    history.push({
      pathname: `/users/`,
      search:
        "?page=" +
        urlPage +
        `&limit=${urlLimit}&orderBy=${property}&order=${orderTemp}`,
    });
    setPaged(urlPage);
    getUsers(urlPage, urlLimit,property, orderTemp);
    setOrder(orderTemp);
    setOrderBy(property);
  };
  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    const user = _cookie ? JSON.parse(_cookie)["teacher_v1"] : {};
    setmyUser({ ...user, page: "users" });
    props.page("users");
    setTeacherId(user?.userId);
    let urlPage = parseInt(paramse.get("page")) || 0;
    let urlLimit = parseInt(paramse.get("limit")) || 25;
    let urlOrderBy =  paramse.get("orderBy") || "createdAt";
    let urlOrder =  paramse.get("order") || "desc";
    if (parseInt(paramse.get("page"))) {
      history.push({
        pathname: `/users/`,
        search:
          "?page=" +
          urlPage +
          `&limit=${urlLimit}&orderBy=${urlOrderBy}&order=${urlOrder}`,
      });
      setPaged(urlPage);
      getUsers(urlPage, urlLimit,urlOrderBy, urlOrder, user);
      GetallClass(user);
    } else {
      history.push({
        pathname: `/users`,
        search: `?page=0&limit=${pageLimit}&orderBy=${orderBy}&order=${order}`,
      });
      getUsers(page, pageLimit,orderBy, order, user);
      setPaged(0);
      GetallClass(user);
    }
  }, []);

  const handleChangeClass = (event) => {
    ////console.logevent.target.value)
    setClassId(event.target.value);
    let selectedClass = allClasses.filter(
      (e) => e._id == event.target.value
    )[0];
    ////console.logselectedClass);
    setClassID(selectedClass.classID);
    setClassName(selectedClass.name);
  };

  const getUsers = async (
    pages,
    limits,
    orderBy,
    order,
    user = myUser
  ) => {
    let res = await getUsersforStudent(
      user?.userId,
      pages,
      limits,
      orderBy,
      order,
      user.token
    );
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      ////console.logres.res.data.data);
      setAllStudent(res?.res?.data?.data?.student);
      let divisor = parseInt(res?.res?.data?.data?.studentcount / limits);
      let remainder = res?.res?.data?.data?.studentcount % limits == 0 ? 0 : 1;
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
    }
  };

  const addStudent = async () => {
    setoldName(loginId.trim());
    let data = {
      loginId: loginId.trim(),
      password: password.trim(),
      classID: classID,
    };
    let res = await createStudent(classId, data, myUser.token);
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
      handleClose();
    } else {
      feedBackMsg(true, "success", res?.res?.data?.msg);
      history.push({
        pathname: `/users/`,
        search:
          "?page=" +
          paged +
          `&limit=${pageLimit}&orderBy=createdAt&order=desc`,
      });
      getUsers(paged, pageLimit, "createdAt", "desc");
      handleClose();
    }
  };

  const deleteHandler = async (studentId) => {
    let res = await deleteStudent(classId, studentId, myUser.token);
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
      handleClose();
    } else {
      feedBackMsg(true, "success", res?.res?.data?.msg);
      let urlPage = parseInt(paramse.get("page")) || 0;
      let urlLimit = parseInt(paramse.get("limit")) || 25;
      let urlOrderBy =  paramse.get("orderBy") || "createdAt";
      let urlOrder =  paramse.get("order") || "desc";
        history.push({
          pathname: `/users/`,
          search:
            "?page=" +
            urlPage +
            `&limit=${urlLimit}&orderBy=${urlOrderBy}&order=${urlOrder}`,
        });
      getUsers(urlPage, urlLimit, urlOrderBy, urlOrder);
      handleClose();
    }
  };

  const GetallClass = async (user) => {
    let res = await getAllClassby(user.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      ////console.logres.res.data.data);
      setAllClasses(res.res.data.data.sclass);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPaged(event.selected);

    getUsers(event.selected, pageLimit, query, orderBy, order);
    history.push({
      pathname: `/users`,
      search:
        "?page=" +
        event.selected +
        `&limit=${pageLimit}&query=${query}&orderBy=${orderBy}&order=${order}`,
    });
  };

  const closeDialog = () => {
    setoldName("");
    setSuccessOpen(false);
    setSuccessMode(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - allStudent.length) : 0;
  return (
    <main style={{ position: "absolute", width: "100%", top: "20%" }}>
      <div className="container px-4 pt-3">
        <div className="upper-section px-60">
          <div className="breadcrumb-menu py-2">
            <Link to={"/"}>Teacher Panel </Link>
            <i className="fas fa-angle-double-right"></i>
            <a className="a">User</a>
          </div>
          <div className="text-blue maintext">
            <h2 className="h2">User List</h2>
          </div>
          <div className="row">
            <div className="col-md-9">
              <div className="card-header px-0">
                <h3 className="h3">Manage Users here</h3>
              </div>
            </div>
            <div className="col-md-3 text-end d-flex justify-content-end">
              <button
                type="button"
                onClick={() => {
                  setOpen(true);
                  setAddMode(true);
                }}
                className="btn btn-primary add-btn px-0 btn-add-size fonted fontAdjust-500"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                data-bs-whatever="@mdo"
              >
                Add New Student &nbsp;&nbsp;
                <img
                  style={{ height: "25px", width: "auto" }}
                  src={Group_305}
                />
              </button>
            </div>
          </div>
          <br />
          <div className="d-flex justify-content-end align-items-end">
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={noOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handleChangePage}
              containerClassName="pagination"
              activeClassName="activePage active"
              forcePage={currPage}
            />
          </div>
        </div>

        <div className=" ps-3 pb-5 class-table class-table1">
          <div className="table-section student-tab">
            <div className=" lower-section p-5">
              <div className="row table-section experiments ">
                <Box sx={{ width: "100%", backgroundColor: "transparent" }}>
                  <Paper
                    sx={{
                      width: "100%",
                      mb: 2,
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    }}
                  >
                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer>
                      <Table
                        sx={{
                          minWidth: 750,
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                        aria-labelledby="tableTitle"
                        size={"small"}
                        stickyHeader
                      >
                        <EnhancedTableHead
                          numSelected={selected.length}
                          order={order}
                          orderBy={orderBy}
                          onSelectAllClick={handleSelectAllClick}
                          onRequestSort={onSetOrder}
                          rowCount={allStudent.length}
                        />
                        <TableBody
                          sx={{
                            backgroundColor: "transparent",
                            color: "#1A273B",
                          }}
                          className="table-body fonted"
                        >
                          {allStudent?.map((item, index) => {
                            const isItemSelected = isSelected(item.loginId);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                hover
                                className="fonted noBord"
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={item.loginId}
                                selected={isItemSelected}
                                style={{
                                  backgroundColor: "transparent",
                                  fontFamily: "Exo2-Regular",
                                }}
                              >
                                <TableCell
                                  align="center"
                                  className="fitted"
                                  sx={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                  }}
                                >
                                  {"Student"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className="fitted"
                                  sx={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                  }}
                                >
                                  {item.loginId}
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className="fitted"
                                  sx={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#7F2490",
                                  }}
                                >
                                  {new Date(
                                    item.createdAt
                                  ).toLocaleDateString()}{" "}
                                  {new Date(
                                    item.createdAt
                                  ).toLocaleTimeString()}
                                </TableCell>
                                <TableCell className="class-btn fonted d-flex justify-content-center">
                                  <div className="px-3">
                                    <Tooltip
                                      title="Edit LoginId"
                                      placement="top"
                                    >
                                      <Link
                                        onClick={() => {
                                          setOpen(true);
                                          setEditLoginIdState(true);
                                          setStudentId(item._id);
                                          setloginId(item.loginId);
                                          setClassId(item.sclass._id);
                                          setoldName(item?.loginId);
                                        }}
                                      >
                                        <img src={Group_332} className="ps-3" />
                                      </Link>
                                    </Tooltip>
                                  </div>
                                  <div className="px-3">
                                    <Tooltip
                                      title="Change Password"
                                      placement="top"
                                    >
                                      <Link
                                        onClick={() => {
                                          setOpen(true);
                                          setUpPwd(true);
                                          setEditMode(true);
                                          setStudentId(item._id);
                                          setloginId(item.loginId);
                                          setClassId(item.sclass._id);
                                          setoldName(item?.loginId);
                                        }}
                                      >
                                        <img src={key} className="ps-3" />
                                      </Link>
                                    </Tooltip>
                                  </div>
                                  <div className="px-3">
                                    <Tooltip title="Delete" placement="top">
                                      <Link
                                        onClick={() => {
                                          setOpen(true);
                                          setDeleteMode(true);
                                          setoldName(item?.loginId);
                                          setStudentId(item._id);
                                          setloginId(item.loginId);
                                          setClassId(item.sclass._id);
                                        }}
                                      >
                                        <img src={Group_299} className="ps-3" />
                                      </Link>
                                    </Tooltip>
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          {emptyRows > 0 && (
                            <TableRow
                              style={{
                                height: (dense ? 33 : 53) * emptyRows,
                              }}
                            >
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              </div>
              {/* <table className="table w-100" style={{ backgroundColor: 'transparent' }}>
                <thead className="mb-5 fonted">
                  <tr>
                    <th scope="col" className="col1 pb-4 fonted" style={{ backgroundColor: 'transparent' }}>UserType</th>
                    <th scope="col" className="col1 pb-4 fonted" style={{ backgroundColor: 'transparent' }}>Login ID</th>
                    <th scope="col" className="col1 pb-4 fonted" style={{ backgroundColor: 'transparent' }}>Created On</th>
                    <th scope="col" className="col1 pb-4 fonted" style={{ backgroundColor: 'transparent' }}>Actions</th>
                  </tr>
                </thead>
                <tbody className="table-body" style={{ backgroundColor: 'transparent' }}>
                  {allStudent.length > 0 && allStudent.map((item, index) => {
                    return (
                      <tr className="noBord">
                        <td className="text-end fonted">{'Student'}</td>
                        <td className="class-btn fonted text-purple"> {item.loginId}</td>
                        <td className="class-btn fonted text-purple"> {new Date(item.createdAt).toLocaleDateString()} {new Date(item.createdAt).toLocaleTimeString()}</td>
                        <td className='class-btn fonted d-flex justify-content-center'>
                          
                            <div className="px-3">
                              <Tooltip title="Edit LoginId" placement="top">
                                <Link onClick={() => {
                                  setOpen(true); setEditLoginIdState(true); setStudentId(item._id); setloginId(item.loginId);
                                  setClassId(item.sclass._id);;setoldName(item?.loginId)
                                }}>
                                  <img src={Group_332} className="ps-3" />
                                </Link>
                              </Tooltip>
                            </div>
                            <div className="px-3">
                              <Tooltip title="Change Password" placement="top">
                                <Link onClick={() => { setOpen(true); setUpPwd(true); setEditMode(true); setStudentId(item._id); setloginId(item.loginId); setClassId(item.sclass._id);setoldName(item?.loginId) }}>
                                  <img src={key} className="ps-3" />
                                </Link>
                              </Tooltip>
                            </div>
                            <div className="px-3">
                              <Tooltip title="Delete" placement="top">
                                <Link onClick={() => { setOpen(true); setDeleteMode(true);;setoldName(item?.loginId); setStudentId(item._id); setloginId(item.loginId); setClassId(item.sclass._id); }}>
                                  <img src={Group_299} className="ps-3" />
                                </Link>
                              </Tooltip>
                            </div>
                          
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table> */}
            </div>
            <div className="col-lg-3c"></div>
          </div>
        </div>
      </div>

      <Dialog
        handleClose={handleClose}
        open={open}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="modal-dialog modal-dialog-centered modal-dialog-scrollable teacher-div"
      >
        <div className="modal-content" style={{ width: "400px" }}>
          <div className="modal-header-n d-flex justify-content-end">
            <button
              type="button"
              onClick={handleClose}
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>
          <form>
            <div className="modal-body px-5">
              <div className="mb-0">
                <label for="recipient-name" className="col-form-label">
                  {upPwd
                    ? "Change Password"
                    : addMode
                    ? "Add Student"
                    : editMode || editLoginIdState
                    ? "Edit Student"
                    : "Delete Student"}
                </label>
                {addMode ? (
                  <>
                    <br />
                    {/* <br/> */}
                    <Box sx={{ minWidth: 100, border: "none" }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Class
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={classId}
                          label="Class"
                          sx={{ height: "50px" }}
                          onChange={handleChangeClass}
                        >
                          {allClasses.map((item, index) => {
                            return (
                              <MenuItem className="xyz" value={item._id}>
                                {item.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      {allClasses.length == 0 ? (
                        <span style={{ color: "red" }}>No Class is added</span>
                      ) : null}
                    </Box>
                    <br />
                    <input
                      type="text"
                      className="form-control1 pt-3"
                      value={loginId}
                      placeholder="Login Id"
                      onChange={(e) => setloginId(e.target.value)}
                      onBlur={(e) => {
                        setStudentTouched({ ...studentTouched, loginId: true });
                        setloginId(e.target.value.trim());
                      }}
                    />
                    <br />
                    <br />
                    <input
                      type="text"
                      className="form-control1 pt-3 "
                      value={password}
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                      onBlur={(e) => setPassword(e.target.value.trim())}
                    />
                    {/* <br /> */}
                    <small style={{ color: "red" }}>
                      Password should be upto 8 characters or more
                    </small>
                  </>
                ) : editLoginIdState ? (
                  <>
                    <input
                      type="text"
                      className="form-control1 pt-3"
                      value={loginId}
                      placeholder="Login Id"
                      onChange={(e) => setloginId(e.target.value)}
                      onBlur={(e) => {
                        setStudentTouched({ ...studentTouched, loginId: true });
                        setloginId(e.target.value.trim());
                      }}
                    />
                  </>
                ) : editMode ? (
                  <>
                    <input
                      type="text"
                      className="form-control1 pt-3 w-100"
                      value={password}
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                      onBlur={(e) => setPassword(e.target.value.trim())}
                      style={{ width: "80%", color: "#262526" }}
                    />
                    <br />
                    <small style={{ color: "red" }}>
                      Password should be upto 8 characters or more
                    </small>
                  </>
                ) : deleteMode ? (
                  <>
                    {/* <h5 class="modal-title1" id="exampleModalLabel">Delete Student</h5> */}
                    <p className="p"></p>
                    <label for="recipient-name" class="col-form-label1">
                      Are you sure you want to delete {loginId}?
                    </label>
                  </>
                ) : null}
              </div>
            </div>
            <div class="modal-footer px-4">
              {/* <button type="button"  class="bntn btn-pitch">Create Student</button> */}
              {addMode || editMode || editLoginIdState ? (
                <>
                  <button
                    type="button"
                    className="btn btn-pitch"
                    onClick={() => {
                      if (upPwd) {
                        if (password.length < 8) {
                          feedBackMsg(
                            true,
                            "error",
                            "Password should be upto 8 or more characters"
                          );
                        } else {
                          editingStudent();
                        }
                      } else {
                        if (addMode) addStudent();
                        else editingStudent();
                      }
                    }}
                    disabled={
                      addMode ? ValidationForm("add") : ValidationForm("edit")
                    }
                  >
                    {addMode ? "Create" : "Update"}
                  </button>
                </>
              ) : deleteMode ? (
                <>
                  <button
                    type="button"
                    className="btn btn-pitch"
                    onClick={() => deleteHandler(studentId)}
                  >
                    Delete
                  </button>
                </>
              ) : null}
            </div>
          </form>
        </div>
      </Dialog>

      <Dialog
        onClose={closeDialog}
        open={successOpen}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="modal-dialog modal-dialog-centered teacher-div"
      >
        <div class="modal-content" style={{ width: "400px" }}>
          <div class="modal-header-n ms-auto pt-3 pb-0 d-flex justify-content-end">
            <button
              type="button"
              class="btn-close"
              onClick={closeDialog}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>
          <div class="modal-body px-5">
            <div class="mb-0">
              {successMode == 1 ? (
                <>
                  <label for="recipient-name" class="col-form-label">
                    <span>{oldName}</span>: Add Student ID{" "}
                    <i class="fas fa-check check ms-3" aria-hidden="true"></i>
                  </label>
                  <p class="submitted py-3 p">
                    Student ID {oldName} successfully added to class {className}
                  </p>
                </>
              ) : successMode == 2 ? (
                <>
                  <label for="recipient-name" class="col-form-label">
                    <span>{oldName}</span>: Edit Student ID{" "}
                    <i class="fas fa-check check ms-3" aria-hidden="true"></i>
                  </label>
                  <p class="submitted py-3 p">
                    Student ID successfully changed from "{oldName}" to "{newID}
                    "
                  </p>
                </>
              ) : successMode == 3 ? (
                <>
                  <label for="recipient-name" class="col-form-label">
                    <span>{oldName}</span>: Edit Student Password{" "}
                    <i class="fas fa-check check ms-3" aria-hidden="true"></i>
                  </label>
                  <p class="submitted py-3 p">
                    Student {oldName} password successfully changed
                  </p>
                </>
              ) : (
                <>
                  <label for="recipient-name" class="col-form-label">
                    <span>{oldName}</span>: Delete{" "}
                    <i class="fas fa-check check ms-3" aria-hidden="true"></i>
                  </label>
                  <p class="submitted py-3 p">{oldName} successfully deleted</p>
                </>
              )}
            </div>
          </div>
        </div>
      </Dialog>
      <div
        class="modal fade"
        id="exampleModal1"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form
              action="action.php"
              id="my-updateForm"
              method="post"
              enctype="multipart/form-data"
              onsubmit="openModal()"
            >
              <div class="modal-body px-4 pb-2">
                <div class="">
                  <label for="recipient-name" class="col-form-label ps-4">
                    Edit Class Name
                  </label>
                  <input
                    type="text"
                    class="modal-form-control px-4"
                    id="recipient-name"
                    placeholder="Test_Class"
                  />
                </div>
              </div>
              <div class="modal-footer px-4">
                <button
                  type="submit"
                  class="btn btn-pitch"
                  name="btn"
                  value="Submit"
                  id="submitBtn"
                  data-bs-toggle="modal"
                  data-bs-target="#confirm-submit"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        class="modal fade bottom"
        tabindex="-1"
        role="dialog"
        id="my-deletedModal"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header ms-auto pt-3 pb-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body px-5">
              <div class="mb-0">
                <label for="recipient-name" class="col-form-label">
                  <span>Test_Class 1</span>: Delete{" "}
                  <i class="fas fa-check check ms-3" aria-hidden="true"></i>
                </label>
                <p class="submitted py-3 p">
                  Test_Class 1 successfully deleted
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade bottom"
        tabindex="-1"
        role="dialog"
        id="my-updateModal"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header ms-auto pt-3 pb-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body px-5">
              <div class="mb-0">
                <label for="recipient-name" class="col-form-label">
                  <span>Test_Class 1</span>: Edit Class Name{" "}
                  <i class="fas fa-check check ms-3" aria-hidden="true"></i>
                </label>
                <p class="submitted py-3 p">
                  Class successfully changed from ------ to ——
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </main>
  );
}
